<!-- TODO: Move to UICL -->
<template>
  <label
    class="group flex w-full items-center justify-between gap-2"
    :for="componentId"
  >
    <input :id="componentId" v-model="model" type="checkbox" class="hidden" />
    <span><slot /></span>
    <div
      class="aspect-[5/3] h-6 rounded-full p-1"
      :class="
        model
          ? 'bg-primary group-hover:bg-primary-600 group-active:bg-primary-700'
          : 'bg-gray-200 group-hover:bg-gray-300 group-active:bg-gray-400'
      "
    >
      <div
        class="aspect-square h-full rounded-full bg-white"
        :class="{ 'ml-auto': model }"
      />
    </div>
  </label>
</template>

<script setup>
import useUid from "@/helpers/uid.js"

const model = defineModel({ type: Boolean, default: false })

const componentId = useUid()
</script>
